module.exports = __webpack_public_path__ + "img/4.6c830e21.svg";